export default {"src":"/_next/static/media/research_rider_jobs.25b39fc4.svg","height":284,"width":284};